import { QueryResult, useQuery } from '@apollo/client'
import {
  CompanyManagerDashboardBoOfCompanyQuery,
  CompanyManagerDashboardBoOfCompanyQueryVariables,
  CompanyManagerDashboardBuOfCompanyQuery,
  CompanyManagerDashboardBuOfCompanyQueryVariables,
  CompanyManagerDashboardBubobumCountersQuery,
  CompanyManagerDashboardBubobumCountersQueryVariables,
  CompanyManagerDashboardBumOfCompanyQuery,
  CompanyManagerDashboardBumOfCompanyQueryVariables,
  RoleName,
} from '../../../types'
import {
  COMPANY_MANAGER_DASHBOARD_BO_OF_COMPANY,
  COMPANY_MANAGER_DASHBOARD_BU_OF_COMPANY,
  COMPANY_MANAGER_DASHBOARD_BUBOBUM_COUNTERS,
  COMPANY_MANAGER_DASHBOARD_BUM_OF_COMPANY,
} from '../business-units-and-branch-offices/Queries'

const businessUnitsAndBranchOfficesDashboardQueryOptions = {
  fetchPolicy: 'cache-first' as const,
}

export const useCompanyManagerDashboardBubobumCounters = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardBubobumCountersQuery, CompanyManagerDashboardBubobumCountersQueryVariables> => {
  return useQuery<CompanyManagerDashboardBubobumCountersQuery, CompanyManagerDashboardBubobumCountersQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_BUBOBUM_COUNTERS,
    {
      variables: { companyId, userDashboardRoles },
      ...businessUnitsAndBranchOfficesDashboardQueryOptions,
    },
  )
}

export const useCompanyManagerDashboardBumOfCompany = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardBumOfCompanyQuery, CompanyManagerDashboardBumOfCompanyQueryVariables> => {
  return useQuery<CompanyManagerDashboardBumOfCompanyQuery, CompanyManagerDashboardBumOfCompanyQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_BUM_OF_COMPANY,
    {
      variables: { companyId, userDashboardRoles },
      ...businessUnitsAndBranchOfficesDashboardQueryOptions,
    },
  )
}

export const useCompanyManagerDashboardBuOfCompany = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardBuOfCompanyQuery, CompanyManagerDashboardBuOfCompanyQueryVariables> => {
  return useQuery<CompanyManagerDashboardBuOfCompanyQuery, CompanyManagerDashboardBuOfCompanyQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_BU_OF_COMPANY,
    {
      variables: { companyId, userDashboardRoles },
      ...businessUnitsAndBranchOfficesDashboardQueryOptions,
    },
  )
}

export const useCompanyManagerDashboardBoOfCompany = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardBoOfCompanyQuery, CompanyManagerDashboardBoOfCompanyQueryVariables> => {
  return useQuery<CompanyManagerDashboardBoOfCompanyQuery, CompanyManagerDashboardBoOfCompanyQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_BO_OF_COMPANY,
    {
      variables: { companyId, userDashboardRoles },
      ...businessUnitsAndBranchOfficesDashboardQueryOptions,
    },
  )
}
